import { useRef } from "react";
import ReactDOM from "react-dom";
import DialogLayout from "./DialogLayout";
import useScrollLock from "../../hooks/useScrollLock";
interface IDialog {
    isOpen: boolean;
    toggle: () => void;
    children: React.ReactNode;
    bgColor?: string;
}

const Dialog = ({ isOpen, toggle, children, bgColor = 'bg-brand-green-5' }: IDialog) => {
    const dialogRef = useRef<HTMLDivElement>(null);

    useScrollLock(isOpen);

    if (!isOpen) return null;

    const dialogContent = (
        <DialogLayout onClose={toggle} bgColor={bgColor}>
            <div ref={dialogRef}>
                {children}
            </div>
        </DialogLayout>
    );

    return ReactDOM.createPortal(dialogContent, document.body);
};

export default Dialog;